import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { convertMilliseconds } from '@swf/core/utils';
import type { ClubRecentTournamentSummary } from '@swf/generated/types/api/v0/SwHomeGames';
import { FormattedUTCDate } from '@swf/poker';

import {
  TXTCLI_Duration,
  TXTCLI_N0_sec,
  TXTCLI_Players,
  TXTCLI_Prize_Pool,
  TXTCLI_Rebuys,
  TXTINT_FORMAT_LongTimeHour,
  TXTINT_FORMAT_LongTimeMin
} from './Summary.messages.json';
import styles from './Summary.scss';

interface Props {
  tournamentSummary: Required<ClubRecentTournamentSummary>;
}

const Summary: React.FC<Props> = ({
  tournamentSummary: { tournName, started, numPlayers, prizePool, closed, rebuys }
}) => {
  const tournamentStart = new Date(started);
  const tournamentStop = new Date(closed);

  const { hours, minutes, seconds } = convertMilliseconds(
    tournamentStop.getTime() - tournamentStart.getTime()
  );
  const shouldShowSeconds = !hours && !minutes;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.tournamentName}>{tournName}</p>
        <div className={styles.tournamentDate}>
          <FormattedUTCDate utcDate={`${tournamentStart}`} options={{ dateStyle: 'long' }} />
        </div>
      </div>
      <div className={styles.body}>
        <p className={styles.key}>
          <Translation {...TXTCLI_Players} />:
        </p>
        <p className={styles.value}>{numPlayers}</p>
        <p className={styles.key}>
          <Translation {...TXTCLI_Prize_Pool} />:
        </p>
        <p className={styles.value}>{prizePool}</p>
        <p className={styles.key}>
          <Translation {...TXTCLI_Duration} />:
        </p>
        <p className={styles.value}>
          {hours ? <Translation {...TXTINT_FORMAT_LongTimeHour} values={{ 0: hours }} /> : ''}
          {minutes ? <Translation {...TXTINT_FORMAT_LongTimeMin} values={{ 0: minutes }} /> : ''}
          {shouldShowSeconds && seconds ? (
            <Translation {...TXTCLI_N0_sec} values={{ 0: seconds }} />
          ) : (
            ''
          )}
        </p>
        <p className={styles.key}>
          <Translation {...TXTCLI_Rebuys} />:
        </p>
        <p className={styles.value}>{rebuys}</p>
      </div>
    </div>
  );
};

export default Summary;
